import React from "react"
import styles from "./styles.scss"
import County from "./County"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, SIZES, TYPES } from "components/Button"
import SearchField from "./SearchField"
import onClickOutside from "react-onclickoutside";
import { getUserPosition, selectUserPosition } from "data/userposition"
import { connect } from "react-redux"
import cx from 'classnames'

class DropdownBox extends React.Component {
  state = {
    listOpen: false,
    inputValue: '',
    selectedCounty: {},
    userLocationLoading: false,
  }

  handleChange = value => {
    this.setState({inputValue: value.target.value})
  }

  toggleList() {
    this.setState(prevState => ({
      listOpen: !prevState.listOpen,
    }))
  }

  handleClickOutside(){
    this.setState({
      listOpen: false
    })
  }

  handleCountyOnClick = county => {
    this.setState({ listOpen:false })
    localStorage.setItem("County",JSON.stringify(county))
    this.props.onSelectCounty(county)
  }
  handlePositionButtonClick = async () => {
    this.setState({userLocationLoading: true})
   await this.props.getUserPosition()
   const { position } = this.props
   const county = this.props.list.filter(item => item.name === position.toString())[0]

   if(county) {
      localStorage.setItem("County",JSON.stringify(county))
      this.setState({ listOpen: false,userLocationLoading: false })
      this.props.onSelectCounty(county)  
    }
    else{
      this.setState({ listOpen: false,userLocationLoading: false })
      alert("Något gick fel, ingen position hittades.")
    }
  }

  render() {
    const { list } = this.props
    const { listOpen, inputValue } = this.state
    const county = JSON.parse(localStorage.getItem("County"))
    return (
      <div className={styles.container}>
        <div
          className={styles.dropdownButton}
          onClick={() => this.toggleList()}
        >
          <div className={styles.arrow}>
            <p>{county? county.name : "Kommun"}</p>
          
          {listOpen ? (
            <FontAwesomeIcon icon="angle-up" />
          ) : (
            <FontAwesomeIcon icon="angle-down" />
          )}
        </div>
        </div>
        
          <div className={cx(styles.dropdownContent, listOpen? styles.slideOut : styles.slideIn)}>
            <FontAwesomeIcon icon="caret-up" className={styles.arrowUp}/>
            {this.state.userLocationLoading ? 
            <Button buttonSize={SIZES.X_LARGE} buttonType={TYPES.LOADING} ><p>Hämtar din plats</p><FontAwesomeIcon icon="spinner" className={styles.spinnericon}/></Button>
            :
            <Button onClick={this.handlePositionButtonClick}  buttonSize={SIZES.X_LARGE} buttonType={TYPES.SUCCESS}> <FontAwesomeIcon icon="map-marker-alt"/> <p>Hitta min position</p> </Button>
            }
            <SearchField value={inputValue} onChange={this.handleChange} />
            <p className={styles.countyHeader}> Välj kommun... </p>
            <div className={styles.dropdownList}>
            {list.map(item => {
             return item.name.toLowerCase().startsWith(inputValue.toLowerCase()) ?  
             <County onClick={this.handleCountyOnClick} county={item} key={item.id} name={item.name} isChecked={county&& item.id === county.id} />: null
            })}
            </div>
          </div>
        
      </div>
    )
  }
}
const mapStateToProps = (state, ownProps) => ({
  position: selectUserPosition(state, ownProps),
})

export default connect(
  mapStateToProps,
  {
    getUserPosition,
  }
)(onClickOutside(DropdownBox))




// WEBPACK FOOTER //
// src/components/SearchBarWrapper/DropdownBox/index.jsx